import type { PlanDefinition } from '@opinix-cloud/shared';

/**
 * Hardcoded fallback for the plan catalog so the marketing /pricing page is
 * never broken by a missing or pre-deploy /api/plans endpoint. Mirrors the
 * shape served by GET /api/plans. Keep in sync with the live STARTER /
 * PRO / ENTERPRISE rows in the `Plan` table — the FREE tier was retired
 * in the plans-editable migration.
 */
export const PLANS_FALLBACK: PlanDefinition[] = [
  {
    tier: 'STARTER',
    name: 'Starter',
    pricePerMonth: 199,
    pricePerYear: 1990,
    tagline: 'For small teams running regular drills.',
    features: [
      '3 appliances',
      '15 users',
      'Unlimited scenarios',
      '200 sessions / month',
      '50 GB recording storage',
      'Email support',
    ],
    limits: {
      users: 15,
      appliances: 3,
      scenarios: -1,
      sessionsPerMonth: 200,
      recordingsGB: 50,
    },
    selfServe: true,
  },
  {
    tier: 'PRO',
    name: 'Pro',
    pricePerMonth: 599,
    pricePerYear: 5990,
    tagline: 'For multi-site agencies and training providers.',
    features: [
      '10 appliances',
      '50 users',
      'Unlimited scenarios',
      'Unlimited sessions',
      '500 GB recording storage',
      'Priority support',
      'Custom branding',
    ],
    limits: {
      users: 50,
      appliances: 10,
      scenarios: -1,
      sessionsPerMonth: -1,
      recordingsGB: 500,
    },
    selfServe: true,
  },
  {
    tier: 'ENTERPRISE',
    name: 'Enterprise',
    pricePerMonth: null,
    pricePerYear: null,
    tagline: 'For agencies, departments, and federal partners.',
    features: [
      'Unlimited appliances',
      'Unlimited users',
      'SSO + SAML',
      '24/7 dedicated support',
      'Custom SLAs',
      'Air-gapped deployments',
      'Custom integrations',
    ],
    limits: {
      users: -1,
      appliances: -1,
      scenarios: -1,
      sessionsPerMonth: -1,
      recordingsGB: -1,
    },
    selfServe: false,
  },
];
